import Store from '../reducers';
import { unreadNotifications } from '../notificationsV2/inboxBridge';

/**
 * Re-reads the unread count and repaints the menu pill.
 *
 * `fallback` is the count a V1 brand already has in hand (the one `initApp` returns); a brand on the
 * V2 inbox has its own, and `unreadNotifications` is what knows which of the two applies. A V1
 * brand with nothing to fall back on gets no refresh rather than a full list fetch.
 */
export const refreshUnread = async (fallback = null) => {
  try {
    const unread = await unreadNotifications(fallback);

    if (typeof unread === 'number') {
      Store.dispatch({ type: 'SET', unread });
    }
  } catch (err) {
    // A failed refresh keeps the last known number: a stale pill beats a wrong one.
    console.log('[notifications] cannot refresh the unread count', err?.message);
  }
};

/**
 * Takes one off, for a notification just read through a click. The event that tells the server
 * rides a queue that may flush seconds later, so asking the server right then would still answer
 * the old number; the next refresh reconciles.
 */
export const decrementUnread = () => {
  const current = Store.getState().notifications || 0;
  Store.dispatch({ type: 'SET', unread: Math.max(0, current - 1) });
};
